// extracted by mini-css-extract-plugin
export default {"row":"OrderSummary_row__tOndG","paymentSection":"OrderSummary_paymentSection__H9lie","buttonStripe":"OrderSummary_buttonStripe__AAPRz"};